import styled from '@emotion/styled';
import { Grid, Typography } from '@mui/material';
import moment from 'moment';
import 'moment-timezone';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { SlimEventData } from '../../api';
import { useLanguage } from '../../utils/GeneralUtils';
import { useOrderPage } from '../orderPageContext/useOrderPage';
import { getTimeFormat } from '../../utils/getDateAndTimeFormat';

type SpecificEventSummaryProps = {
  specificEvent: SlimEventData;
};

export const StyledImage = styled('img')({
  width: '100%',
  height: 'auto',
  maxWidth: '100%',
  borderRadius: '8px',
});
export const SpecificEventSummary = ({ specificEvent }: SpecificEventSummaryProps) => {
  const { orderPageState } = useOrderPage();
  const { t } = useTranslation();
  const language = useLanguage();
  const timeFormat = getTimeFormat(orderPageState?.account || undefined);

  const format = language === 'he' ? 'DD MMMM,  yyyy' : 'MMMM DD, yyyy';
  return (
    <Grid container flexDirection="column" mt={4} gap={1} flexWrap="nowrap" alignItems="center">
      <Grid item container gap={2} mt={3}>
        <Typography variant="h5" fontWeight="800">
          {t('order_page.date')}
        </Typography>
        <Typography variant="h5">{moment(specificEvent.date).format(format)}</Typography>
      </Grid>

      <Grid item container gap={2}>
        <Typography variant="h5" fontWeight="800">
          {t('order_page.hour')}
        </Typography>
        <Typography variant="h5">{moment.unix(specificEvent.time).tz('utc').format(timeFormat)}</Typography>
      </Grid>
      {specificEvent.tickets_left < 10 && (
        <Grid item container gap={2}>
          <Typography variant="h5" fontWeight="900" color="orange">
            {t('order_page.ticketsLeft', { ticketsLeft: specificEvent.tickets_left })}
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};
